import { render } from "./ProductSearch.vue?vue&type=template&id=6bacb408&scoped=true"
import script from "./ProductSearch.vue?vue&type=script&lang=js"
export * from "./ProductSearch.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=6bacb408&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bacb408"]])

export default __exports__